import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TUser {
  username: string;
  language: number;
  roles: string[];
}

export interface IUser extends TUser {}

const User = Model(
  (model: TUser): IUser => {
    const _user: TUser = Object.assign({}, model);

    let create = (user: IUser): IUser => {
      let obj = ValidatableObject(user);
      return obj;
    };

    let user = {
      get username() {
        return _user.username;
      },
      set username(value) {
        _user.username = value;
      },
      get language() {
        return _user.language;
      },
      set language(value) {
        _user.language = value;
      },
      get roles() {
        return _user.roles;
      },
      set roles(value) {
        value.forEach((role) => _user.roles.push(role));
      },
    };

    return create(user);
  }
);

export default User;
